import React, { useState } from "react";
import styles from "./GalleryView.module.css";
import Icon from "../common/Icon";

interface GalleryViewProps {
    moveButtonEvents: moveButtonEvents;
}

export interface moveButtonEvents {
    onLeftClick: ((e: React.MouseEvent<HTMLElement>) => void) | undefined;
    onRightClick: ((e: React.MouseEvent<HTMLElement>) => void) | undefined;
}
const GalleryView = (props: GalleryViewProps) => {
    return (
        <>
            <div className={styles.frame}>
                <div
                    className={` ${styles.right} ${styles.icon}`}
                    onClick={props.moveButtonEvents.onRightClick}
                >
                    <Icon name="arrowForward" size="small" color="darkGrey" />
                </div>
                <div
                    className={`${styles.left} ${styles.icon}`}
                    onClick={props.moveButtonEvents.onLeftClick}
                >
                    <Icon name="arrowBack" size="small" color="darkGrey" />
                </div>
            </div>
        </>
    );
};

export default GalleryView;
